<template>
	<div>
		<v-layout row justify-center>
			<v-dialog
				:value="true"
				scrollable
				fullscreen
				hide-overlay>
				<div v-shortkey="['esc']" @shortkey="$emit('close')"></div>
				<v-card color="background">
					<v-card-title class="pa-0 primary">
						<v-spacer></v-spacer>
						<span class="title color--text">
							{{ toolbarTitle }}
						</span>
						<v-spacer></v-spacer>
						<v-btn large icon class="m-1 color--text" @click="$emit('close')">
							<v-icon large>close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pa-0">
						<Babel
							:multiselect="multiselect"
							:no_select="false"
							:props_card_type="card_type"
							@selected="$emit('selected', $event);$emit('close')">
						</Babel>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-layout>

	</div>
</template>

<script>
import Babel from '@/components/babel.vue'
export default {
	props: [
		'multiselect',
		'toolbarTitle',
		'card_type'
	],
	name: 'babel_modal',
	components: { Babel }
}
</script>

<style scoped lang="stylus">
.v-card__title
	max-height: 48px
</style>



// WEBPACK FOOTER //
// src/components/modal_babel.vue